import { render, staticRenderFns } from "./carFreeOpenReason.vue?vue&type=template&id=bfa36d94&"
import script from "./carFreeOpenReason.vue?vue&type=script&lang=js&"
export * from "./carFreeOpenReason.vue?vue&type=script&lang=js&"
import style0 from "./carFreeOpenReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports